import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="relative z-10 bg-[var(--footer-bg)] text-white mt-20 pt-16 pb-8 transition-theme border-t border-white/5">
      <div className="container mx-auto px-6 max-w-6xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <div className="inline-flex items-center gap-2 mb-6 group cursor-default px-4 py-3 rounded-2xl border-2 border-white/20 bg-white">
              <img 
                src="/images/P__1_-removebg-preview (1).png" 
                alt="PreciQube Logo" 
                className="w-8 h-8 object-contain brand-logo transition-transform group-hover:scale-110 [--logo-glow:none]" 
              />
              <span className="text-xl font-bold tracking-tight text-[#1a1d23]">PreciQube</span>
            </div>
            <p className="text-white/40 text-sm leading-relaxed max-w-xs">
              Next-generation diagnostic systems utilizing quantum-enhanced optical sensing for early stage cancer detection.
            </p>
          </div>
          
          <div>
            <h4 className="font-semibold mb-6 text-white/80">Quick Links</h4>
            <ul className="space-y-4 text-white/40 text-sm">
              <li><Link to="/" className="hover:text-[var(--accent-blue)] transition-colors">Home</Link></li>
              <li><Link to="/solutions" className="hover:text-[var(--accent-blue)] transition-colors">Solutions</Link></li>
              <li><Link to="/team" className="hover:text-[var(--accent-blue)] transition-colors">Team</Link></li>
              <li><Link to="/contact" className="hover:text-[var(--accent-blue)] transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-6 text-white/80">Connect</h4>
            <ul className="space-y-4 text-white/40 text-sm">
              <li>Email: prakhar.ph20@alumni.iitm.ac.in</li>
              <li>Address: Indian Institute of Technology Madras Chennai, Tamil Nadu, 600036</li>
              <li>
                <Link to="/contact" className="inline-block bg-[var(--accent-blue)] hover:brightness-110 text-white px-6 py-2 rounded-lg transition-all font-medium shadow-lg shadow-blue-500/20">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-white/20">
          <p>© 2025 PreciQube. All rights reserved.</p>
          <div className="flex gap-6">
            <a href="#" className="hover:text-white/40 transition-colors">Privacy</a>
            <a href="#" className="hover:text-white/40 transition-colors">Terms</a>
            <a href="#" className="hover:text-white/40 transition-colors">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;